import { useInfiniteQuery } from "@tanstack/react-query";
import { getWidgetSearchFeed } from "@/services/v2/widgetService";
import { buildWidgetSearchQuery } from "@/helpers/widgetSearchFilters";

// Search/filtered "Show More" feed for the embed search widget. Kept
// separate from useWidgetWantAds (the plain chrome-less widget's hook,
// which stays as-is) since the query key here needs to react to the full
// filter state, not just sortType.
const useWidgetSearchFeed = ({ widgetKey, filterState, enabled = true }) => {
  // Only the parts of filterState that change the request go in the key -
  // Sets don't compare structurally, so key on the already-flattened params.
  const baseParams = buildWidgetSearchQuery(filterState, { page: 1 });
  const { page: _page, ...keyParams } = baseParams;

  return useInfiniteQuery({
    queryKey: ["widgetSearchFeed", widgetKey, keyParams],
    enabled: !!widgetKey && enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      const params = buildWidgetSearchQuery(filterState, { page: pageParam });
      const res = await getWidgetSearchFeed(widgetKey, params);
      return res?.result || { data: [], totalCount: 0 };
    },
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.reduce((sum, p) => sum + (p?.data?.length || 0), 0);
      return loaded < (lastPage?.totalCount || 0) ? allPages.length + 1 : undefined;
    },
    select: (result) => ({
      ads: result.pages.flatMap((p) => p?.data || []),
      totalCount: result.pages[0]?.totalCount || 0,
    }),
  });
};

export default useWidgetSearchFeed;
